import Modal from '../../common/Modal'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import SubmitButton from '../../common/buttons/SubmitButton'
import MCElement from '../../common/MCElement'
import { ReactComponent as WarningIcon } from '../../../assets/images/common/icons/warning-icon.svg'

import styles from './CapacityWarningModal.module.scss'
import classNames from 'classnames'

const CapacityWarningModal = ({ showModal, closeModal, onSubmit, spotsAvailable, eventId, status }) => {
  const { t } = useTranslation()
  let capacityWarningDisabledEventsIds = JSON.parse(sessionStorage.getItem('capacityWarningDisabledEventsIds')) || []
  const [isSelected, setIsSelected] = useState(capacityWarningDisabledEventsIds?.includes(eventId))

  const savePreferences = () => {
    isSelected
      ? capacityWarningDisabledEventsIds = capacityWarningDisabledEventsIds.filter(id => id !== eventId)
      : capacityWarningDisabledEventsIds.push(eventId)

    setIsSelected(!isSelected)
    sessionStorage.setItem('capacityWarningDisabledEventsIds', JSON.stringify(capacityWarningDisabledEventsIds))
  }

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      className={styles.capacityWarningModal}
      autoFocus
    >
      <div className={classNames('d-flex flex-column align-items-center', styles.modalContainer)}>
        <div className='d-flex justify-content-center align-items-center'>
          <WarningIcon/>
        </div>
        <div className={styles.modalContent}>
          <span className={styles.title}>{t('events.modal.capacityWarning.title')}</span>
          <p className='mt-2 mb-4'>
            {t('events.modal.capacityWarning.message', { capacity: spotsAvailable + 1 })}
          </p>
          <div className='w-100'>
            <SubmitButton
              onClick={() => onSubmit(status)}
              buttonMessage={t('common.action.continue')}
              buttonColor='orange-button'
            />
            <SubmitButton
              onClick={closeModal}
              buttonMessage={t('common.cancel')}
              buttonColor='navy-button'
            />
          </div>
          <div className='d-flex w-100 align-items-center justify-content-center mt-4 mb-2'>
            <MCElement
              type='checkbox'
              isSelected={isSelected}
              clicked={savePreferences}
            />
            <p className='ml-3'>{t('events.modal.capacityWarning.dontShowAgain')}</p>
          </div>
        </div>
      </div>
    </Modal>
  )
}

CapacityWarningModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  spotsAvailable: PropTypes.number.isRequired,
  eventId: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
}

export default CapacityWarningModal
